module.exports = __webpack_public_path__ + "img/timeline.52ed3670.jpg";